import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { industries } from '../../data/industries';
import { SectionHeading } from '../SectionHeading';
export function ExperienceDirectory() {
  return <section id="experience" className="w-full bg-paper py-20 lg:py-28" data-id="element-120" data-mp="53sk8m30czg6">
      <div className="mx-auto max-w-shell px-6 lg:px-10" data-id="element-121" data-mp="12yy9y94lupx">
        <SectionHeading title="Experience" intro="A directory of specialized functional areas. Select an industry for the full governance and execution profile." data-id="element-122" data-mp="3sabeob26q44s" />

        <ul className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3" data-id="element-123" data-mp="3iki2p8y4rn00">
          {industries.map(industry => <li key={industry.slug} className="flex" data-id="element-124" data-mp="3dlp1aew4bmg7">
              <Link to={`/experience/${industry.slug}`} className="group flex w-full flex-col border border-line bg-white p-7 transition-colors duration-150 ease-exec hover:border-navy-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-500 focus-visible:ring-offset-2" data-id="element-125" data-mp="3dn8ic7plm1j1">
                <span className="flex items-start justify-between gap-4" data-id="element-126" data-mp="1waad78xlpy9e">
                  <h3 className="font-display text-xl font-semibold leading-snug text-navy-900" data-id="element-127" data-mp="1wcepof9kg5la">
                    {industry.name}
                  </h3>
                  <ArrowUpRightIcon className="mt-1 h-4 w-4 flex-none text-gold-600 transition-transform duration-150 ease-exec group-hover:-translate-y-0.5 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-128" data-mp="1mlsc0qletp58" />
                </span>
                <p className="mt-4 text-[15px] leading-relaxed text-muted" data-id="element-129" data-mp="21ag60sflxqt2">
                  {industry.summary}
                </p>
                <span className="mt-auto pt-7 text-xs font-semibold uppercase tracking-[0.14em] text-navy-900" data-id="element-130" data-mp="266wuxoums977">
                  View profile
                </span>
              </Link>
            </li>)}
        </ul>
      </div>
    </section>;
}